import { useState } from 'react'

const useToggle = () => {
  const [isOpen, setOpen] = useState(false)

  const open = () => setOpen(true)
  const close = () => setOpen(false)
  const toggle = () => setOpen((prev) => !prev)

  return {
    isOpen,
    open,
    close,
    toggle
  }
}

export type Toggle = ReturnType<typeof useToggle>

export default useToggle
